const PermissionEnum = {
    Gaau: {
        Adicionar: "Gaau.Adicionar", 
        Visualizar: "Gaau.Visualizar", 
        Remover: "Gaau.Remover",
        Editar: "Gaau.Editar",
        ImagemRemover: "Gaau.Imagem.Remover",
        AdicionarHistorico: "Gaau.Adicionar.Historico"
    },

};

export default PermissionEnum;
